// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Loading__loading___kZxl8{display:flex;align-items:center;justify-content:center;flex-direction:column;height:100%;padding:24px;min-height:200px}.Loading__loading___kZxl8{animation:appear-in 0.1s linear;animation-fill-mode:both}.Loading__loadingTitle___3CdwG{font-size:18px;font-weight:500;text-transform:uppercase;color:#AAA;margin-bottom:12px;margin-top:24px}.Loading__loadingSubtitle___vSkcn{padding:0 12px;color:#BBB}\n", ""]);
// Exports
exports.locals = {
	"loading": "Loading__loading___kZxl8",
	"loadingTitle": "Loading__loadingTitle___3CdwG",
	"loadingSubtitle": "Loading__loadingSubtitle___vSkcn"
};
module.exports = exports;
